export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderFiles@2x.png";